import { useAuth } from "../components/context/AuthContext";
import { BORROWER, INVESTOR } from "../constants/constants";

export const IsInvestor = () => {
  const { user } = useAuth();
  return user?.user_type === INVESTOR;
};

export const IsBorrower = () => {
  const { user } = useAuth();
  return user?.user_type === BORROWER;
};

export const IsOnboared = () => {
  const { user } = useAuth();
  return checkIsOnbarded(user);
};

/**
 * Returns true once the user has SUBMITTED their KYC (uploaded ID front +
 * back, entered NIN and DOB). Does not require admin verification.
 *
 * Prefers the backend's authoritative `kyc_complete` field (added in Sprint
 * B) and falls back to a client-side check for clients on an older API.
 */
export const checkIsOnbarded = (user: any): boolean => {
  if (!user) return false;
  if (user.is_verified === true) return true; // admin-approved → always done
  if (typeof user.kyc_complete === "boolean") return user.kyc_complete;
  // Fallback for older backends — match the server-side definition exactly
  // (selfie/image joined the required set alongside the ID sides).
  return (
    !!user.nin &&
    !!user.dateofbirth &&
    !!user.id_front &&
    !!user.id_back &&
    !!user.image
  );
};

/**
 * Returns the granular KYC status: "missing" | "incomplete" |
 * "pending_review" | "verified". Use this to render the KYC card on the
 * Account page with the right colour + CTA.
 */
export const kycStatus = (user: any): string => {
  if (!user) return "missing";
  if (typeof user.kyc_status === "string") return user.kyc_status;
  // Fallback derivation
  if (user.is_verified) return "verified";
  if (checkIsOnbarded(user)) return "pending_review";
  if (user.nin || user.dateofbirth || user.id_front || user.id_back) {
    return "incomplete";
  }
  return "missing";
};

export const IsAdmin = () => {
  const { user } = useAuth();
  return Boolean(user?.is_staff || user?.is_superuser);
};
